import React from "react";
import { Alert } from "@picklebet/ui";
import { Typography } from "@picklebet/ui";
import { Button } from "@picklebet/ui";
import { useGameSessions } from "@/features/casino/hooks/useGameSessions";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { Skeleton } from "@picklebet/ui";
import cx from "classnames";

import * as styles from "./shared.module.scss";

const TITLE = "Deposits will be added to your active Casino session.";

const ActiveGameSessionDepositInfo = ({
  hasCTA = true,
  className,
}: { hasCTA?: boolean; className?: string }) => {
  const setModal = useShellStore((state) => state.setModal);
  const { hasActiveGameSession, isLoading } = useGameSessions(true);

  if (isLoading) {
    return (
      <Skeleton
        className={cx(styles.skeletonAlert, { [styles.small]: !hasCTA })}
      />
    );
  }

  if (!hasActiveGameSession) {
    return null;
  }

  return (
    <Alert
      color="info"
      size={hasCTA ? "large" : "small"}
      title={hasCTA ? TITLE : undefined}
      className={className}
    >
      {hasCTA ? (
        <div>
          <Typography variant="body" noSpacing>
            End your active Casino session to access your funds to bet and
            withdraw.
          </Typography>
          <Button
            variant="info"
            size="sm"
            className={styles.alertButton}
            onClick={() => setModal("endGameSession")}
          >
            End Session
          </Button>
        </div>
      ) : (
        TITLE
      )}
    </Alert>
  );
};

export { ActiveGameSessionDepositInfo };
